import { render, staticRenderFns } from "./OfferView2.vue?vue&type=template&id=77055aeb&scoped=true"
import script from "./OfferView2.vue?vue&type=script&lang=js"
export * from "./OfferView2.vue?vue&type=script&lang=js"
import style0 from "./OfferView2.vue?vue&type=style&index=0&id=77055aeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77055aeb",
  null
  
)

export default component.exports